module.exports = __webpack_public_path__ + "static/media/Yarco LAT Decision.8f4dd5d9.pdf";